import type { ReactNode } from "react";

import { cx } from "@akaike/ui";

interface SegmentedControlProps<T extends string> {
  value: T;
  options: { value: T; label: ReactNode }[];
  onChange: (value: T) => void;
  brand?: boolean;
  className?: string;
}

export function Seg<T extends string>({ value, options, onChange, brand, className }: SegmentedControlProps<T>) {
  return (
    <div data-slot="segmented-control" className={cx("seg", className)} role="tablist">
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={cx(active && "on", brand && active && "brand")}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
